import { accountFromDto } from '../../account.dto';

export class Controller {

    /** @ngInject */
    constructor($state, $uibModal, AccountsResource, Alert, SharedEmailAccountModal) {
        this.$state = $state;
        this.$uibModal = $uibModal;
        this.AccountsResource = AccountsResource;
        this.Alert = Alert;
        this.SharedEmailAccountModal = SharedEmailAccountModal;
    }

    $onInit() {
        this.account = accountFromDto(this.account, this.account.companyUser);
    }

    resendVerificationEmail() {
        this.isSending = true;
        this.AccountsResource
            .resendVerificationEmail(this.companyId, this.account.id)
            .then(() => this.Alert('success', 'company.user-directories.manage-account.details.resent-verification'))
            .finally(() => this.isSending = false)
    }

    invalidateVerificationLink() {
        this.isInvalidating = true;
        this.AccountsResource
            .removeAccountVerificationEmail(this.companyId, this.account.id)
            .then(() => this.$state.reload('company.user-directories.manage-account'))
            .finally(() => this.isInvalidating = false)
    }

    showDeleteAccountModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageAccountRemove',
                resolve: {
                    accountId: () => this.account.id,
                    companyId: () => this.companyId,
                },
            }).result
            .then(() => this.$state.go('company.user-directories'))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.remove.removed'))
    }

    showRemoveOwnerModal() {
        this.$uibModal
            .open({
                component: 'companyUserDirectoriesManageAccountRemoveOwner',
                resolve: {
                    accountId: () => this.account.id,
                    companyId: () => this.companyId,
                },
            }).result
            .then(() => this.$state.go('^', {}, {reload: '^'}))
            .then(() => this.Alert('success', 'company.user-directories.manage-account.owner.remove.removed'))
    }

    showShareModal() {
        this.isOpeningModal = true;
        this.SharedEmailAccountModal(this.account.username, this.account.companyUser.id)
            .then(() => this.$state.reload('company.user-directories.manage-account'))
            .finally(() => this.isOpeningModal = false)
    }
}



// WEBPACK FOOTER //
// ./src/portal/states/company/user-directories/manage-account/details/account-details.controller.js